/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Files = (props: SVGProps) => (
    <AccessibleSVG width={40} height={40} viewBox="0 0 40 40" {...props}>
        <ellipse cx="30.2857" cy="33.2857" rx="4.28571" ry="4.28571" fill="#E5EFFA" />
        <ellipse cx="7.85714" cy="4.85714" rx="2.85714" ry="2.85714" fill="#E5EFFA" />
        <rect
            x="10"
            y="8.59796"
            width="16.4948"
            height="24.7423"
            rx="1.5"
            fill="#E5EFFA"
            stroke="#0061D5"
            strokeWidth="1.5"
        />
        <rect
            x="13.299"
            y="2"
            width="16.4948"
            height="24.7423"
            rx="1.5"
            fill="white"
            stroke="#0061D5"
            strokeWidth="1.5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.0104 6.79895C17.0104 5.97052 17.6819 5.29895 18.5104 5.29895H30.8936C31.3481 5.29895 31.778 5.50497 32.0627 5.85917L35.2362 9.80698C35.4503 10.0734 35.5671 10.4049 35.5671 10.7468V28.5412C35.5671 29.3696 34.8955 30.0412 34.0671 30.0412H18.5104C17.6819 30.0412 17.0104 29.3696 17.0104 28.5412V6.79895Z"
            fill="white"
            stroke="#0061D5"
            strokeWidth="1.5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.5155 15.1959C20.2878 15.1959 20.1031 15.3805 20.1031 15.6082C20.1031 15.836 20.2878 16.0206 20.5155 16.0206H32.0619C32.2897 16.0206 32.4743 15.836 32.4743 15.6082C32.4743 15.3805 32.2897 15.1959 32.0619 15.1959H20.5155ZM20.5155 17.2577C20.2878 17.2577 20.1031 17.4423 20.1031 17.6701C20.1031 17.8978 20.2878 18.0825 20.5155 18.0825H32.0619C32.2897 18.0825 32.4743 17.8978 32.4743 17.6701C32.4743 17.4423 32.2897 17.2577 32.0619 17.2577H20.5155ZM20.1031 19.732C20.1031 19.5042 20.2878 19.3196 20.5155 19.3196H27.1135C27.3412 19.3196 27.5258 19.5042 27.5258 19.732C27.5258 19.9597 27.3412 20.1444 27.1135 20.1444H20.5155C20.2878 20.1444 20.1031 19.9597 20.1031 19.732ZM28.9279 19.3196C28.7001 19.3196 28.5155 19.5042 28.5155 19.732C28.5155 19.9597 28.7001 20.1444 28.9279 20.1444H30.5774C30.8051 20.1444 30.9897 19.9597 30.9897 19.732C30.9897 19.5042 30.8051 19.3196 30.5774 19.3196H28.9279Z"
            fill="#0061D5"
        />
        <path
            d="M35.1546 9.83501H31.6969C31.3291 9.83501 31.0309 9.5354 31.0309 9.16903V5.7113"
            stroke="#0061D5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </AccessibleSVG>
);

export default Files;
